import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CanvasToggleButton } from '@mygpt/app/chat/components/Canvas/ToggleButton';
import { ratingType } from '@mygpt/types';
import { ChatContentBottomButtonsProps } from '../ChatContentBottomButton';
import { DislikeButton, LikeButton } from '@mygpt/app/chat/components/FeedbackButton';
import { TTSButton } from '@mygpt/app/chat/components/ChatContentBottomButton/TTSButton';
import { CopyButton } from '@mygpt/app/chat/components/ChatContentBottomButton/CopyButton';
import { TransferToHumanButton } from '@mygpt/app/chat/components/ChatContentBottomButton/TransferToHumanButton';
import { useMemo } from 'react';
import { useBot } from '@mygpt/app/bot';
import { cleanAgentContent } from '@mygpt/app/utils/agent';

export const DesktopView = ({
  item,
  id,
  sessionId,
  pageSource,
  enableTTS,
  isPlaying,
  ttsLoading,
  onTTSPlayOrPause,
  copied,
  setCopied,
  floatingActions,
  isDigitalHuman,
}: ChatContentBottomButtonsProps) => {
  const { t } = useTranslation();
  const { robotInfo } = useBot();

  const configs = useMemo(() => {
    return robotInfo?.configs;
  }, [robotInfo]);

  let showTransferToHuman = !!configs?.feedback_form?.content || !!configs?.feedback_form?.forward_chat_history;

  console.log('showTransferToHuman', showTransferToHuman);

  // 桌面端布局（保持原样）
  return (
    <div className={`${floatingActions && 'xl:absolute xl:right-0 xl:top-0 xl:translate-x-full xl:pl-2 pt-1'} mt-1`}>
      <Group justify="space-between">
        <Group gap={5} wrap="nowrap">
          <TTSButton
            text={item.text}
            isPlaying={isPlaying}
            ttsLoading={ttsLoading}
            onTTSPlayOrPause={onTTSPlayOrPause}
            enableTTS={enableTTS}
            isDigitalHuman={isDigitalHuman}
          />

          <LikeButton
            aiId={id}
            sessionId={sessionId}
            messageId={item.messageId || ''}
            rating={item.rating as ratingType}
            pageSource={pageSource}
            isDigitalHuman={isDigitalHuman}
          />
          <DislikeButton
            aiId={id}
            sessionId={sessionId}
            messageId={item.messageId || ''}
            rating={item.rating as ratingType}
            pageSource={pageSource}
            isDigitalHuman={isDigitalHuman}
          />

          {/* 清理 Agent 特殊标签，只保留 ANSWER 内容用于复制 */}
          <CopyButton
            text={cleanAgentContent(item.text)}
            copied={copied}
            setCopied={setCopied}
            isDigitalHuman={isDigitalHuman}
          />

          {showTransferToHuman && <TransferToHumanButton messageId={item.messageId || ''} />}
        </Group>

        <CanvasToggleButton
          messageId={item.messageId || ''}
          canvas_url={item.canvas_url || ''}
          canvas_title={item.canvas_title || ''}
        />
      </Group>
    </div>
  );
};
